/**
 * The mergeById function combines two arrays of objects,
 * adding items from the second array only if their id is not already in the first array.
 * This prevents duplicates based on the id.
 */
export function mergeById<T extends { id: number }>(arrayOne: T[], arrayTwo: T[]): T[] {
  return [
    ...arrayOne,
    ...arrayTwo.filter((itemTwo) => !arrayOne.some((itemOne) => itemOne.id === itemTwo.id)),
  ];
}
